import { HistoryActionTypes } from '../../actions/usersActions/actionType';

const initialState = {
    history: null,
    isCMS: false
}

const updateObject = (oldState, updatedProps) => {
    return {
        ...oldState,
        ...updatedProps
    }
}

export const historyReducer = (state = initialState, action) => {
    switch (action.type) {
        case HistoryActionTypes.ADD_HISTORY:
            return updateObject(state,
                {
                    history: action.payload,
                });
            
        case HistoryActionTypes.IS_CMS:
            return updateObject(state,{
                isCMS: action.payload
            })

        default: return state;
    }
}